<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="guias-rejeitadas"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
  >
  <ng-container header>
    <div class="filters-row flex align-items-center">
      @if (tabIndex === 0) {
        <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>
      }
      @if (tabIndex === 1) {
        <ag-views-toolbar
          [grid]="agGridAgregado"
          [gridKey]="GRID_KEY_AGREGADO"
          class="mr-2"
        ></ag-views-toolbar>
      }

      <bl-competencia
        class="mr-2"
        [competencia]="activeCompetenciaRange[0]"
        [competenciaFinal]="activeCompetenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>
      <p-floatlabel variant="on">
        <p-select
          size="small"
          class="p-inputwrapper-filled"
          [options]="lancamentoOptions"
          [(ngModel)]="selectedLancamento"
          (onChange)="resetPagination()"
        ></p-select>
        <label>Lançamento</label>
      </p-floatlabel>
      @if (tabIndex === 0) {
        <bl-guias-rejeitadas-filtro
          [(data)]="filterData"
          [motivoGuiaOptions]="motivoGuiaOptions"
          [motivoItemOptions]="motivoItemOptions"
          (onChange)="resetPagination()"
        ></bl-guias-rejeitadas-filtro>
      }

      @if (tabIndex === 0) {
        <button
          data-smartpresentation="botao-pesquisar"
          pButton
          type="button"
          icon="pi pi-search"
          iconPos="left"
          label="Pesquisar"
          class="mr-4 p-button p-button-md"
          [ngClass]="{ 'p-disabled': !filterChanged }"
          [disabled]="!filterChanged"
          (click)="reloadData(true)"
        ></button>
      }

      @if (tabIndex === 1) {
        <button
          data-smartpresentation="botao-pesquisar"
          pButton
          type="button"
          icon="pi pi-search"
          iconPos="left"
          label="Pesquisar"
          class="mr-4 p-button p-button-md"
          [ngClass]="{ 'p-disabled': !filterChangedAgregado }"
          [disabled]="!filterChangedAgregado"
          (click)="reloadDataAgregado()"
        ></button>
      }

      <bl-pesquisar-input
        class="ml-5 mr-5"
        (onSearch)="onSearch($event)"
        [disabled]="tabIndex === 0 ? !rowData?.length : !rowDataAgregado?.length"
      ></bl-pesquisar-input>

      <!--
      <button
        class="p-button p-button-outlined p-button-icon-only mr-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="tabIndex === 0 ? !rowData?.length : !rowDataAgregado?.length"
        >
        <i class="pi pi-file-excel"></i>
      </button>
      -->

      <ng-container>
        <button
          pTooltip="Exportar Listagem como XLSX"
          tooltipPosition="bottom"
          [disabled]="tabIndex === 0 ? !rowData?.length : !rowDataAgregado?.length || filterChanged"
          class="p-button p-button-outlined p-button-icon-only"
          (click)="abrirMenuExportacao($event, exportMenu)"
          pRipple
          >
          <i class="pi pi-file-export"></i>
        </button>

        <p-menu #exportMenu [popup]="true" [model]="exportMenuItems" styleClass="menu-exportacao"></p-menu>
      </ng-container>

      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
        >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
          >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-column flex-1 min-h-0">
    <p-tabs class="flex flex-column flex-1 min-h-0" [(value)]="tabIndex" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab [value]="0">Listagem de guias rejeitadas</p-tab>
        <p-tab [value]="1">Resumo de guias rejeitadas</p-tab>
      </p-tablist>
      <p-tabpanels>
      <p-tabpanel [value]="0">
        <div class="grid-wrapper">
          <ag-grid-angular
            #agGrid
            data-smartpresentation="ag-grid"
            class="ag-theme-balham w-full h-full"
            [style.height]="gridHeight$ | async"
            [rowData]="rowData"
            [gridOptions]="gridOptions"
            [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
            >
          </ag-grid-angular>

          <div class="grid-footer">
            <small>Último processamento em: {{ dtUltimoProcessamento || '-' }}</small>
          </div>
        </div>
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <div class="grid-wrapper">
          <ag-grid-angular
            #agGridAgregado
            data-smartpresentation="ag-grid-agregado"
            class="ag-theme-balham w-full h-full"
            [style.height]="gridHeight$ | async"
            [rowData]="rowDataAgregado"
            [gridOptions]="gridOptionsAgregado"
            [overlayLoadingTemplate]="firstLoadAgregado ? 'Clique em Pesquisar para exibir os registros' : null"
            >
          </ag-grid-angular>

          <div class="grid-footer">
            <small>Último processamento em: {{ dtUltimoProcessamentoResumo || '-' }}</small>
          </div>
        </div>
      </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    @if (tabIndex === 0) {
      <div class="pagination-container flex justify-content-center mt-3">
        <bl-pagination
          [data]="rowData"
          [total]="rowTotal"
          [(page)]="page"
          [(size)]="pageSize"
          [(reset)]="paginationReset"
          (onChange)="onPageChange($event)"
          >
        </bl-pagination>
      </div>
    }
  </div>
</bl-page-card-container>

<p-dialog
  [(visible)]="detalheGuiaDisplay"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  >
  <ng-template pTemplate="header">
    <div class="flex justify-content-between w-full">
      <h5>Detalhes da guia/lançamento</h5>
      <div class="flex align-items-center gap-2 mr-2">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-left"
          class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
          (click)="showDetalheGuiaForPrev()"
          [disabled]="detalheGuiaCodigoIndex <= 0"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-right"
          class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
          (click)="showDetalheGuiaForNext()"
          [disabled]="detalheGuiaCodigoIndex > guiasList.length - 2"
        ></button>
      </div>
    </div>
  </ng-template>

  <bl-detalhes-guia
    [operadora]="operadora"
    [cdGuiaMonitor]="detalheGuiaCodigo"
    (onChange)="showDetalheGuiaFor($event)"
  ></bl-detalhes-guia>
</p-dialog>

